/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { useSelector } from 'react-redux';
import { FSBTable } from 'components/common/FSBTable';
import { defaultDeleteFilter, showSequenceNumber } from 'utils/constants';
import { DEMANDS_QUERY, DEMANDS_SUBSCRIPTION_QUERY } from 'utils/CommonGraphQL';
import { cloneDeep, isEmpty } from 'lodash';
import { vendorDemandsColumns } from 'components/Drawers/components/VendorDetailsDrawer/constant';

const MyDemands = () => {
  const { selectedVendor } = useSelector((state) => state.vendorDetailsReducer);

  const [filters, setFilters] = useState({
    filter: [
      { key: 'trader', value: selectedVendor?.id, type: 'INT', op: 'EQ' },
      { ...defaultDeleteFilter },
    ],
    pageNo: 1,
    pageSize: 10,
    sortCol: 'createdAt',
    sortDirection: 'DESC',
  });

  const { data, loading, error, subscribeToMore } = useQuery(DEMANDS_QUERY, {
    variables: filters,
    fetchPolicy: 'network-only',
  });

  const onSortChange = (sort) => {
    setFilters({
      ...filters,
      sortCol: sort()[0].id,
      sortDirection: sort()[0].desc ? 'DESC' : 'ASC',
    });
  };
  const handlePageChange = ({ pageSize, pageNo }) => {
    setFilters({
      ...filters,
      pageNo,
      pageSize,
    });
  };

  const sortBy = [
    filters.sortCol === null
      ? { id: null, desc: null }
      : {
          id: filters.sortCol,
          desc: filters.sortDirection === 'DESC',
        },
  ];

  const findIndexOfItem = (item) => {
    return vendorDemandsColumns.findIndex((itm) => itm.accessorKey === item);
  };
  vendorDemandsColumns[findIndexOfItem('SNo')].cell = (cell) =>
    showSequenceNumber(cell, filters);

  useEffect(() => {
    const deletedObj = filters.filter.filter((val) => val.key !== 'isDeleted');
    const unsubscribe = subscribeToMore({
      document: DEMANDS_SUBSCRIPTION_QUERY,
      variables: { ...filters, filter: deletedObj },
      updateQuery: (prev, { subscriptionData }) => {
        const newData = cloneDeep(prev);
        const indexFound = newData.demands?.demands?.findIndex(
          (val) => val.id === subscriptionData?.data?.demands?.demand?.id,
        );
        if (!prev || isEmpty(prev)) return '';
        if (!subscriptionData.data) return prev;
        if (subscriptionData.data.demands.action === 'CREATED') {
          const newDemand = subscriptionData.data.demands.demand;
          const updatedDemands = [newDemand, ...newData.demands.demands];

          const newTotalCount = prev.demands.totalCount + 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          newData.demands = {
            ...newData.demands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            demands: updatedDemands,
          };
        }
        if (subscriptionData.data.demands.action === 'UPDATED') {
          newData.demands.demands[indexFound] =
            subscriptionData.data.demands.demand;
        }

        if (subscriptionData.data.demands.action === 'DELETED') {
          const { id } = subscriptionData.data.demands.demand; // ID of the demand to remove
          const prevDemands = prev.demands.demands;

          const updatedDemands = prevDemands.filter((val) => val.id !== id);

          const newTotalCount = prev.demands.totalCount - 1;
          const newTotalPages = Math.ceil(newTotalCount / filters.pageSize);

          const updatedDemandsData = {
            ...newData.demands,
            totalCount: newTotalCount,
            totalPages: newTotalPages,
            demands: updatedDemands,
          };

          newData.demands = updatedDemandsData;
        }

        return newData;
      },
    });

    return () => unsubscribe();
  }, []);

  if (error) return `There is an error on this page : ${error.message} `;

  return (
    <FSBTable
      data={(data && data?.demands?.demands) || []}
      totalCount={(data && data?.demands?.totalCount) || 0}
      totalPages={(data && data?.demands?.totalPages) || 0}
      columns={vendorDemandsColumns}
      currentPageNo={filters.pageNo}
      keyField="id"
      search={false}
      pagination
      remote
      loading={loading}
      striped={false}
      hover={false}
      bordered={false}
      wrapperClass="table-responsive word-break"
      pageSize={filters.pageSize}
      handlePageChange={handlePageChange}
      onSortChange={onSortChange}
      sorting={sortBy}
    />
  );
};
export default MyDemands;
